import { Box, TextField } from '@mui/material';

import { ReactComponent as ArrowUp } from '../../../assets/arrow-up.svg';
import { ReactComponent as ArrowDown } from '../../../assets/arrow-down.svg';

export default function NumberInput ({
  value,
  step = 1,
  max = 100,
  min = 0,
  onChange,
}: {
  value: number;
  step?: number;
  max?: number;
  min?: number;
  onChange: (val: number) => void;
}) {
  return (
    <Box sx={style}>
      <TextField
        inputProps={{
          inputMode: 'numeric',
          pattern: '[0-9]*',
          style: { paddingRight: '50px', textAlign: 'center' },
        }}
        style={{ width: '115px' }}
        value={value}
        onChange={e => {
          const newValue = e.target.value;
          if (newValue === '') {
            onChange(min);
          } else {
            onChange(Math.min(Math.max(parseInt(newValue), min), max));
          }
        }}
      />
      <div
        style={{
          display: 'flex',
          position: 'relative',
          left: '-35px',
          top: '0px',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#006EC2 0% 0% no-repeat padding-box',
            border: '1px solid #006EC2',
            borderRadius: '2px',
            width: '35px',
            flexGrow: 1,
          }}
          onClick={() => { onChange(Math.min(value + step, max)); }}
          className="hover-pointer"
        >
          <ArrowUp height="9px" width="13px" />
        </div>
        <div
          style={{ background: 'white', top: 'calc(50% - 0.5px)', height: '1px', width: '24px', position: 'absolute' }}
        ></div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#006EC2 0% 0% no-repeat padding-box',
            border: '1px solid #006EC2',
            borderRadius: '2px',
            width: '35px',
            flexGrow: 1,
          }}
          onClick={() => { onChange(Math.max(value - step, min)); }}
          className="hover-pointer"
        >
          <ArrowDown height="9px" width="13px" />
        </div>
      </div>
    </Box>
  );
}

const style = {
  display: 'flex',
  '& .hover-pointer': {
    '&:hover': {
      cursor: 'pointer',
    },
  },
};
